// @ts-expect-error
import {createAction} from 'redux-act';

import type {
    ComparedActivityReportSummary,
    ComparisonRangeType,
    ReportRowData,
} from 'nutshell-core/types';

export const ActionTypes = {
    TASK_REPORT_FETCH_SUMMARY_REQUEST: 'TASK_REPORT_FETCH_SUMMARY_REQUEST',
    TASK_REPORT_FETCH_SUMMARY_SUCCESS: 'TASK_REPORT_FETCH_SUMMARY_SUCCESS',
    TASK_REPORT_FETCH_SUMMARY_FAILURE: 'TASK_REPORT_FETCH_SUMMARY_FAILURE',
} as const;

type SummaryRequestPayload = {
    filters: any;
    comparisonType: ComparisonRangeType | null | undefined;
};
type SummaryPayload = {
    data: ComparedActivityReportSummary<Array<ReportRowData>>;
    totals: ComparedActivityReportSummary<ReportRowData>;
};

export type TaskReportSummaryRequestAction = {
    type: 'TASK_REPORT_FETCH_SUMMARY_REQUEST';
    payload: SummaryRequestPayload;
};
export type TaskReportSummarySuccessAction = {
    type: 'TASK_REPORT_FETCH_SUMMARY_SUCCESS';
    payload: SummaryPayload;
};
export type TaskReportSummaryFailureAction = {
    type: 'TASK_REPORT_FETCH_SUMMARY_FAILURE';
    error: true;
    payload: unknown | null | undefined;
};

export type TaskReportAction =
    | TaskReportSummaryRequestAction
    | TaskReportSummarySuccessAction
    | TaskReportSummaryFailureAction;

/*------------------------------------------------------------------------------
| Action Creators
| ------------------------------------------------------------------------------*/
export const requestTaskReportActivities = createAction('TASK_REPORT_ACTIVITIES_REQUESTED');
export const updateTaskReportActivities = createAction('TASK_REPORT_ACTIVITIES_UPDATED');
export const failTaskReportActivities = createAction('TASK_REPORT_ACTIVITIES_FAILED');

export const requestTaskReportSummary = (
    payload: SummaryRequestPayload
): TaskReportSummaryRequestAction => ({type: 'TASK_REPORT_FETCH_SUMMARY_REQUEST', payload});
export const resolveTaskReportSummary = (
    payload: SummaryPayload
): TaskReportSummarySuccessAction => ({type: 'TASK_REPORT_FETCH_SUMMARY_SUCCESS', payload});
export const failTaskReportSummary = (err: unknown): TaskReportSummaryFailureAction => ({
    type: 'TASK_REPORT_FETCH_SUMMARY_FAILURE',
    payload: err,
    error: true,
});
